import { useState } from "react";
import { Navbar } from "./home/Navbar";
import { Hero } from "./home/Hero";
import { ResonanceRibbon } from "./home/ResonanceRibbon";
import { WhyThisMatters } from "./home/WhyThisMatters";
import { ScrollStory } from "./home/ScrollStory";
import { SixDoorways } from "./home/SixDoorways";
import { EcosystemShowcase } from "./home/EcosystemShowcase";
import { StoryScroll, ResonanceNote } from "./home/StoryScroll";
import { FounderVision } from "./home/FounderVision";
import { Ecosystem } from "./home/Ecosystem";
import { TestimonialSpotlight } from "./home/TestimonialSpotlight";
import { MusicalCatalysts } from "./home/MusicalCatalysts";
import { PortalsOfAwe } from "./home/PortalsOfAwe";
import { QuizBand } from "./home/QuizBand";
import { Footer } from "./home/Footer";
import { StartingPointSelector } from "./home/StartingPointSelector";
import { CursorGlow } from "./home/CursorGlow";
import { DiscoveryPopup } from "./home/DiscoveryPopup";
import { CookieConsent } from "./home/CookieConsent";
import { GATEWAY_STORY } from "../data/homeContent";

const Seam = () => <div className="gme-seam" aria-hidden="true" />;

export default function HomePage() {
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [initialDoorway, setInitialDoorway] = useState(null);
  const openSelector = (doorwayId) => {
    setInitialDoorway(doorwayId || null);
    setSelectorOpen(true);
  };

  return (
    <div className="gme-canvas relative min-h-screen">
      <CursorGlow />
      <div className="relative z-10">
      <Navbar />

      {/* ENTER THE WORLD */}
      <Hero onFind={openSelector} />
      <ResonanceRibbon />
      <Seam />

      {/* UNDERSTAND THE MOMENT */}
      <WhyThisMatters />
      <Seam />

      {/* SEE THE IDEA COME ALIVE — the six doorways */}
      <ScrollStory
        id="resonance-intelligence"
        testid="ri-scroll-story"
        eyebrow="Ways to Enter"
        title={"Six Doorways into"}
        titleGold={"Resonance\nIntelligence"}
        sub="Many paths. Find yours."
        stack
        items={GATEWAY_STORY}
        variant="center"
      />
      <Seam />

      {/* WHAT BRINGS YOU HERE — the six doorways (light) */}
      <SixDoorways light onFind={openSelector} />
      <Seam />

      {/* SEE THE IMPACT */}
      <TestimonialSpotlight />
      <Seam />

      {/* MEET GARY — after the worldview & impact are established */}
      <FounderVision />
      <Seam />

      {/* FEEL IT — musical catalysts */}
      <MusicalCatalysts />
      <Seam />

      {/* CHANGE THE RESONANCE — typographic crescendo */}
      <StoryScroll />
      <ResonanceNote />
      <Seam />

      {/* ONE VISION / ECOSYSTEM */}
      <EcosystemShowcase />
      <Ecosystem />
      <Seam />

      {/* JOIN / INVITE / PARTNER / EXPERIENCE */}
      <PortalsOfAwe />
      <QuizBand onFind={openSelector} />
      <Footer />
      </div>

      <DiscoveryPopup onFind={openSelector} />
      <CookieConsent />
      <StartingPointSelector open={selectorOpen} onClose={() => setSelectorOpen(false)} initialDoorway={initialDoorway} />
    </div>
  );
}
